import { render, staticRenderFns } from "./BusDataSyncDocDetailSetList.vue?vue&type=template&id=2681ae24&scoped=true&"
import script from "./BusDataSyncDocDetailSetList.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncDocDetailSetList.vue?vue&type=script&lang=js&"
import style0 from "./BusDataSyncDocDetailSetList.vue?vue&type=style&index=0&id=2681ae24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2681ae24",
  null
  
)

export default component.exports